import React, { useState } from 'react';

const OutputReportManualInsert = ({ onInsert, loading, lockedRecipientPartyId }) => {
    const [expanded, setExpanded] = useState(false);
    const [form, setForm] = useState({
        FkCaseDocumentId: '',
        FkReportGuid: '',
        FkDocumentId: '',
        FkDocumentRecipientId: '',
        Description: '',
        Name: '',
        SubscriberType: 'Manual',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const today = new Date().toISOString().split('T')[0];
        const thirtyDaysLater = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

        const model = {
            FkCaseDocumentId: parseInt(form.FkCaseDocumentId, 10),
            FkReportGuid: form.FkReportGuid,
            // On the per-user page the recipient is always the profile party (review #7).
            FkDocumentRecipientId: lockedRecipientPartyId || parseInt(form.FkDocumentRecipientId, 10),
            Description: form.Description,
            Name: form.Name,
            SubscriberType: form.SubscriberType,
            AccessValidFrom: today,
            AccessValidTill: thirtyDaysLater,
        };

        if (form.FkDocumentId) {
            model.FkDocumentId = parseInt(form.FkDocumentId, 10);
        }

        onInsert(model);
    };

    return (
        <div style={{ marginBottom: '20px', border: '1px solid #ddd', padding: '10px' }}>
            <h4
                style={{ cursor: 'pointer', userSelect: 'none' }}
                onClick={() => setExpanded(!expanded)}
            >
                {expanded ? '▼' : '▶'} Manual Insert (Testing)
            </h4>
            {expanded && (
                <form onSubmit={handleSubmit}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', alignItems: 'end' }}>
                        <div>
                            <label>CaseDocument ID *</label>
                            <input type="number" name="FkCaseDocumentId" value={form.FkCaseDocumentId}
                                onChange={handleChange} className="form-control" required />
                        </div>
                        <div>
                            <label>Report GUID *</label>
                            <input type="text" name="FkReportGuid" value={form.FkReportGuid}
                                onChange={handleChange} className="form-control" required />
                        </div>
                        <div>
                            <label>Document ID</label>
                            <input type="number" name="FkDocumentId" value={form.FkDocumentId}
                                onChange={handleChange} className="form-control" />
                        </div>
                        {!lockedRecipientPartyId && (
                            <div>
                                <label>Recipient Party ID *</label>
                                <input type="number" name="FkDocumentRecipientId" value={form.FkDocumentRecipientId}
                                    onChange={handleChange} className="form-control" required />
                            </div>
                        )}
                        <div>
                            <label>Description</label>
                            <input type="text" name="Description" value={form.Description}
                                onChange={handleChange} className="form-control" />
                        </div>
                        <div>
                            <label>File Name</label>
                            <input type="text" name="Name" value={form.Name}
                                onChange={handleChange} className="form-control" />
                        </div>
                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                            {loading ? 'Inserting...' : 'Insert Record'}
                        </button>
                        <span style={{ marginLeft: '10px', color: '#888' }}>
                            AccessValidFrom = today, AccessValidTill = today + 30 days
                        </span>
                    </div>
                </form>
            )}
        </div>
    );
};

export default OutputReportManualInsert;
